import React from "react";
import styled from 'styled-components';

import NanoFlex from './../Global/NanoFlex';

const StyledSpinner = styled.div`
    padding: 40px;
    .loading-container{
          position: relative;
          top: 0;
          left: 0;
          width: 20px;
          height: 20px;
          transform: scale(.2);
          animation: rotateIcon 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;

          .icon-principal{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
          .icon-secondary{
            position: absolute;
            top: 0;
            left: 0;
            .icon-wrapper{
              overflow: hidden;
              animation: loading 1s linear infinite;
            }
          }
        }

        @keyframes loading{
          0%{
            height: 1px;
          }
          100%{
            height: 30px;
          }
        }

        @keyframes rotateIcon {

          0% {
            transform: rotateY(0deg);
          }
          50% {
            transform: rotateY(180deg);
          }
  
          100% {
            transform: rotateY(360deg);
          }
        }


`;

const Spinner = (props) => {
    return (
        <StyledSpinner>
            <NanoFlex flexDirection={'column'}>
                <div className="loading-container">
                    <div className="icon-principal">
                        <div className="icon-wrapper">
                            <svg width="20px" viewBox="0 0 58 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 1.36483H12.0627L42.4672 40.9449V2.90026L58 0V65H44.2849L15.5328 27.2966V65H0V1.36483Z" fill="#F8F8F8" />
                            </svg>
                        </div>
                    </div>
                    <div className="icon-secondary">
                        <div className="icon-wrapper">
                            <svg width="20" viewBox="0 0 58 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 1.36483H12.0627L42.4672 40.9449V2.90026L58 0V65H44.2849L15.5328 27.2966V65H0V1.36483Z" fill="#00A8E1" />
                            </svg>
                        </div>
                    </div>
                </div>
            </NanoFlex>
        </StyledSpinner>
    );
};

export default Spinner;

// --- // Documentation // --- //
/*

import Spinner from './../Nano/Spinner.js';

<Spinner />
*/
